import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { Data2Service } from 'src/app/common/data2.service';
import { InfoboxService } from 'src/app/common/infobox/infobox.service';
import { LoaderService } from 'src/app/common/loader/loader.service';

@Component({
	selector: 'app-transports-table',
	templateUrl: './transports-table.component.html',
	styleUrls: ['./transports-table.component.css'],
})
export class TransportsTableComponent implements OnInit {
	transport = {
		id: null,
		name: null,
		side: null,
	};
	data: Array<any> = [];
	citiesConnections: Array<any> = [];

	constructor(
		private readonly api: Data2Service,
		private readonly infobox: InfoboxService,
		private readonly loader: LoaderService,
		private readonly route: ActivatedRoute,
	) {}

	ngOnInit(): void {
		this.loader.show();
		this.transport.id = this.route.snapshot.params.id;
		this.api.get('/bag/bagTransports/' + this.transport.id, (result, error) => {
			if (error) {
				return;
			}
			this.transport = result.data;
		});
		this.loadData();
	}

	private loadData(): void {
		this.api.get('/bag/bagTransportsTimetable/' + this.transport.id, (result, error) => {
			if (error) {
				this.loader.hide();
				return;
			}
			const citiesFromTo = [];
			this.data = result.data.map((transport, index) => {
				citiesFromTo.push(transport.city);
				if (['BR', 'DO', 'TG', 'CR'].includes(transport.cityType)) {
					transport.timeEditable = true;
				}
				// lock traffic and stopTime changes for first city in traffic
				if (transport == result.data.filter((obj) => obj.vehicle == transport.vehicle)[0]) {
					transport.stopTimeEditable = false;
				} else {
					transport.stopTimeEditable = true;
				}
				if (!transport.traffic) {
					transport.traffic = 0;
				}
				if (!transport.stopTime) {
					transport.stopTime = 0;
				}
				if (!transport.fee) {
					transport.fee = 0;
				}
				return transport;
			});
			this.api.get('/bag/bagStopsConnections/?cities=' + [...new Set(citiesFromTo)], (result, error) => {
				this.citiesConnections = result.data;
			});
			this.loader.hide();
		});
	}

	submit(): void {
		if (!this.checkIfAllCitiesHaveDate()) {
			return;
		}
		this.loader.show();
		this.api.put('/bag/bagTransportsTimetable/' + this.transport.id, this.data, (result, error) => {
			this.loader.hide();
			if (error) {
				return;
			}
			const data = this.data.map((transport) => {
				return {
					city: transport.city,
					vehicle: transport.vehicle,
					stopTime: transport.stopTime,
					traffic: transport.traffic,
				};
			});
			this.api.put('/bag/bagTransportsParameters/' + this.transport.id, data, (result, error) => {
				this.loader.hide();
				if (error) {
					return;
				}
				this.infobox.success('Zapisano');
			});
		});
	}

	private checkIfAllCitiesHaveDate(): boolean {
		for (const transport of this.data) {
			if (!transport.date || !transport.time) {
				this.infobox.error('Brak daty i godziny dla: ' + transport.cityName);
				return false;
			}
		}
		return true;
	}

	// private checkIfCitiesHaveSameHours(): boolean {
	// 	for (let transport of this.data) {
	// 		let otherCities = this.data.filter(obj => obj != transport && obj.city == transport.city)
	// 		for (let city of otherCities) {
	// 			if (city.date != transport.date || city.time != transport.time) {
	// 				this.infobox.error("Różne godziny dla miasta: " + transport.cityName)
	// 				return false
	// 			}
	// 		}
	// 	}
	// 	return true
	// }
}
